
import { gql } from '@apollo/client/core';

export const GET_USER_DATA = gql`
  query GetUser($id: ID!) {
    data {
      id
      attributes{
      email
      username
      role {
        name
      }
    }
    }
  }
`;



export const GET_FULLNAME_BY_ID = gql`
      query GetFullnameById($id: ID!) {
        resident(id: $id) {
          data{
          id
          attributes{
            firstname
            lastname           
          }   
        }       
        }
      }
    `;

export const GET_MELPRIVACYPOLICIES = gql`
  query {
    melprivacypolicies {
    data{
    id
    attributes{
      title
      effectivedate
      sections {
        heading
        body
      }
}
}
    }
  }
`;

export const GET_MELTERMSOFUSE = gql`
  query {
    meltermsofuses {
    data{
    id
    attributes{
      title
      effectivedate
      sections {
        heading
        body
      }
}
}
    }
  }
`;


export const GET_RESIDENTS = gql`
query{
    residents {
      data{
        id
        attributes{
            firstname
            lastname
            nickname
            dob
            gender
            address
            race
            dnr
            dnrtype
            specialinstruction
            pressuresore
            admissiondate
            medcart
            roomnumber
            allergy
            diagnosis
            diet
            phone
            email
            hiv
            locationfrom
            mothername
            fathername
            city
            state
            countryofbirth
            religion
            spousename
            personpayingforcare
            personpayingforcarephone
            occupation
            idnumber
            military
            hospital
            hcs
            ssn
            maritalstatus
            referredby
            livingwill
            glasses
            denture
            codestatus
            mobilitydevice
            status
            clientid  
            users_permissions_users {
              data {
                id             
              }
            }       
        }
      }
    }
  }
`;

export const UPDATE_RESIDENT = gql`
  mutation UpdateResident($id: ID!, $data: ResidentInput!) {
    updateResident(id: $id, data: $data) {
      data {
        id
        attributes {
          firstname
          lastname
          nickname
          dob
          gender
          address
          race
          dnr
          dnrtype
          specialinstruction
          pressuresore
          admissiondate
          medcart
          roomnumber
          allergy
          diagnosis
          diet
          phone
          email
          hiv
          locationfrom
          mothername
          fathername
          city
          state
          countryofbirth
          religion
          spousename
          personpayingforcare
          personpayingforcarephone
          occupation
          idnumber
          military
          hospital
          hcs
          ssn
          maritalstatus
          referredby
          livingwill
          glasses
          denture
          codestatus
          mobilitydevice
          status
          clientid
          users_permissions_users {
            data {
              id             
            }
          }
        }
      }
    }
  }
`;


export const CREATE_RESIDENT = gql`
  mutation CreateResident($data: ResidentInput!) {
    createResident(data: $data) { 
        data{     
      attributes {
        firstname
          lastname
          nickname
          dob
          gender
          address
          race
          dnr
          dnrtype
          specialinstruction
          pressuresore
          admissiondate
          medcart
          roomnumber
          allergy
          diagnosis
          diet
          phone
          email
          hiv
          locationfrom
          mothername
          fathername
          city
          state
          countryofbirth
          religion
          spousename
          personpayingforcare
          personpayingforcarephone
          occupation
          idnumber
          military
          hospital
          hcs
          ssn
          maritalstatus
          referredby
          livingwill
          glasses
          denture
          codestatus
          mobilitydevice
          status
          publishedAt
      }
    }
    }
  }
`;

export const GET_DOCUMENTS_BY_RESIDENT = gql`
query GetDocumentsByResident($residentId: ID!) {
  residentdocuments(filters: { resident: { id: { eq: $residentId } } }) {
    data {
      id
      attributes {
        documentname
        description
        documenttype
        expiredate   
        resident {
          data {
            id
            attributes {
              firstname
              lastname
            }
          }
        }
      }
    }
  }
}
`;

export const GET_DOCUMENTS = gql`
query{
    residentdocuments{
      data{
        id
        attributes{
            documentname
            description
            documenttype
            expiredate                             
        }
      }
    }
  }
`;

export const UPDATE_DOCUMENT = gql`
  mutation UpdateResidentdocument($id: ID!, $data: ResidentdocumentInput!) {
    updateResidentdocument(id: $id, data: $data) {
      data {
        id
        attributes {
            documentname
            description
            documenttype
            expiredate
        }
      }
    }
  }
`;

export const CREATE_DOCUMENT = gql`
  mutation Createresidentdocument($data: ResidentdocumentInput!) {
    createResidentdocument(data: $data) { 
        data{     
      attributes {
        documentname
            description
            documenttype
            expiredate
          publishedAt
      }
    }
    }
  }
`;

export const GET_CONTACTS_BY_RESIDENT = gql`
query GetContactsByResident($residentId: ID!) {
  residentcontacts(filters: { resident: { id: { eq: $residentId } } }) {
    data {
      id
      attributes {
        firstname
        lastname
        contacttype
        duties
        address
        city
        state
        zipcode
        notes
        homephone
        businessphone
        mobilephone  
        email   
        resident {
          data {
            id
            attributes {
              firstname
              lastname
            }
          }
        }
      }
    }
  }
}
`;


export const GET_CONTACTS = gql`
query{
    residentcontacts{
      data{
        id
        attributes{
            firstname
            lastname
            contacttype
            duties
            address
            city
            state
            zipcode
            notes
            homephone
            businessphone
            mobilephone  
            email                           
        }
      }
    }
  }
`;

export const UPDATE_CONTACT = gql`
  mutation UpdateResidentcontact($id: ID!, $data: ResidentcontactInput!) {
    updateResidentcontact(id: $id, data: $data) {
      data {
        id
        attributes {
          firstname
          lastname
          contacttype
          duties
          address
          city
          state
          zipcode
          notes
          homephone
          businessphone
          mobilephone  
          email
        }
      }
    }
  }
`;

export const CREATE_CONTACT = gql`
  mutation Createresidentcontact($data: ResidentcontactInput!) {
    createResidentcontact(data: $data) { 
        data{     
      attributes {
        firstname
         lastname
          contacttype
          duties
          address
          city
          state
          zipcode
          notes
          homephone
          businessphone
          mobilephone  
          email
          publishedAt
      }
    }
    }
  }
`;

export const GET_INSURANCES_BY_RESIDENT = gql`
query GetInsurancesByResident($residentId: ID!) {
  residentinsurances(filters: { resident: { id: { eq: $residentId } } }) {
    data {
      id
      attributes {
        providername
        groupno
        insuranceidno
        insurancetype
        resident {
          data {
            id
            attributes {
              firstname
              lastname
            }
          }
        }
      }
    }
  }
}
`;


export const GET_INSURANCES = gql`
query{
    residentinsurances{
      data{
        id
        attributes{
            providername
            groupno
            insuranceidno
            insurancetype                   
        }
      }
    }
  }
`;

export const UPDATE_INSURANCE = gql`
  mutation UpdateResidentinsurance($id: ID!, $data: ResidentinsuranceInput!) {
    updateResidentinsurance(id: $id, data: $data) {
      data {
        id
        attributes {
          providername
          groupno
          insuranceidno
          insurancetype  
        }
      }
    }
  }
`;

export const CREATE_INSURANCE = gql`
  mutation Createresidentinsurance($data: ResidentinsuranceInput!) {
    createResidentinsurance(data: $data) { 
        data{     
      attributes {
        providername
        groupno
        insuranceidno
        insurancetype
        publishedAt
      }
    }
    }
  }
`;

export const GET_PROVIDERS_BY_RESIDENT = gql`
query GetProvidersByResident($residentId: ID!) {
  residentproviders(filters: { resident: { id: { eq: $residentId } } }) {
    data {
      id
      attributes {
        providername
            phone
            email
            address
            providertype  
        resident {
          data {
            id
            attributes {
              firstname
              lastname
            }
          }
        }
      }
    }
  }
}
`;


export const GET_PROVIDERS = gql`
query{
    residentproviders{
      data{
        id
        attributes{
            providername
            phone
            email
            address
            providertype                   
        }
      }
    }
  }
`;

export const UPDATE_PROVIDER = gql`
  mutation UpdateResidentprovider($id: ID!, $data: ResidentproviderInput!) {
    updateResidentprovider(id: $id, data: $data) {
      data {
        id
        attributes {
          providername
          phone
          email
          address
          providertype   
        }
      }
    }
  }
`;

export const CREATE_PROVIDER = gql`
  mutation Createresidentprovider($data: ResidentproviderInput!) {
    createResidentprovider(data: $data) { 
        data{     
      attributes {
        providername
        phone
        email
        address
        providertype 
        publishedAt
      }
    }
    }
  }
`;

export const GET_VITALS_BY_RESIDENT = gql`
  query GetVitalsByResident($residentId: ID!) {
    residentvitals(filters: { resident: { id: { eq: $residentId } } }) {
      data {
        id
        attributes {
          vitaltype
          value
          note
          daterecorded
          startdate
          enddate
          sizetype
          witnesstype
          activitytype
          continencetype
          consistencytype 
          resident {
            data {
              id
              attributes {
                firstname
                lastname
              }
            }
          }
        }
      }
    }
  }
`;

export const GET_VITALS = gql`
query{
    residentvitals{
      data{
        id
        attributes{            
          vitaltype
          value
          note
          daterecorded
          startdate
          enddate
          sizetype
          witnesstype
          activitytype
          continencetype
          consistencytype
        }
      }
    }
  }
`;
export const CREATE_VITAL = gql`
  mutation Createresidentvital($data: ResidentvitalInput!) {
    createResidentvital(data: $data) { 
        data{     
      attributes {
        vitaltype
          value
          note
          daterecorded
          startdate
          enddate
          sizetype
          witnesstype
          activitytype
          continencetype
          consistencytype
        publishedAt
      }
    }
    }
  }
`;

export const UPDATE_VITAL = gql`
  mutation UpdateResidentvital($id: ID!, $data: ResidentvitalInput!) {
    updateResidentvital(id: $id, data: $data) {
      data {
        id
        attributes {
          vitaltype
          value
          note
          daterecorded
          startdate
          enddate
          sizetype
          witnesstype
          activitytype
          continencetype
          consistencytype
        }
      }
    }
  }
`;

export const GET_CHARTINGS = gql`
query{
    residentchartings{
      data{
        id
        attributes{
            daterecordedfrom
            daterecordedto
            notetype
            chartingnote              
	    taker
        }          
      }
    }
  }
`;


export const GET_RESIDENTS_BY_USER = gql`
  query GetResidentsByUser($userId: ID!) {
    residents(filters: {
      users_permissions_users: {
        id: { eq: $userId }
      }
    }
    sort: "firstname:asc"  ) {
      data {
        id
        attributes {
          firstname
          lastname
          dob
          address
          admissiondate
            medcart
            roomnumber
            status
          users_permissions_users {
            data {
              id
              attributes {
                fullname
              }
            }
          }
        }
      }
    }
  }
`;

export const GET_CHARTINGS_BY_RESIDENT = gql`
  query GetChartingsByResident(
    $residentId: ID!,
    $pagination: PaginationArg,
    $startDate: DateTime,
    $sort: [String],
    $endDate: DateTime
  ) {
    residentchartings(
      filters: {
        resident: { id: { eq: $residentId } }
        daterecordedfrom: {
          gte: $startDate
          lte: $endDate
        }
      }
      sort: $sort      
      pagination: $pagination
    ) {
      data {
        id
        attributes {
          daterecordedfrom
          daterecordedto
          notetype
          chartingnote  
          taker
          users_permissions_user {
            data {
              id
               attributes {
                fullname
              }
            }
          }
          resident {
            data {
              id
              attributes {
                firstname
                lastname
              }
            }
          }
        }
      }
    }
  }
`;



export const CREATE_CHARTING = gql`
  mutation Createresidentcharting($data: ResidentchartingInput!) {
    createResidentcharting(data: $data) { 
        data{     
      attributes {
        daterecordedfrom
        daterecordedto
        notetype
        chartingnote  
	      taker
        publishedAt
        users_permissions_user {
            data {
              id
            }
          }
      }
    }
    }
  }
`;

export const UPDATE_CHARTING = gql`
  mutation UpdateResidentcharting($id: ID!, $data: ResidentchartingInput!) {
    updateResidentcharting(id: $id, data: $data) {
      data {
        id
        attributes {
          daterecordedfrom
          daterecordedto
          notetype
          chartingnote 
	        taker
        }
      }
    }
  }
`;

export const DELETE_CHARTING = gql`
  mutation DeleteResidentcharting($id: ID!) {
    deleteResidentcharting(id: $id) {
      data {
        id
      }
    }
  }
`;

export const GET_ADLS_BY_RESIDENT = gql`
query GetAdlsByResident($residentId: ID!) {
  residentadls(filters: { resident: { id: { eq: $residentId } } }) {
    data {
      id
      attributes {
        adl
        adltype
        detail          
        startdate
        enddate
        minute
        remind
        status 
        resident {
          data {
            id
            attributes {
              firstname
              lastname
            }
          }
        }
        residentschedules{
          data{
            id
            attributes{   
              time         
              type
              mo
              tu
              we
              th
              fr
              sa
              su
            }
          }
        }
      }
    }
  }
}
`;

export const GET_ADLS = gql`
query{
    residentadls{
      data{
        id
        attributes{            
          adl
          adltype
          detail          
          startdate
          enddate
          minute
          remind
          status
        }
      }
    }
  }
`;

export const CREATE_ADL = gql`
  mutation Createresidentadl($data: ResidentadlInput!) {
    createResidentadl(data: $data) { 
        data{  
          id   
      attributes {
        adl
        adltype
        detail          
        startdate
        enddate
        minute
        remind
        status
        publishedAt
      }
    }
    }
  }
`;
export const UPDATE_ADL = gql`
  mutation Updateresidentadl($id: ID!, $data: ResidentadlInput!) {
    updateResidentadl(id: $id, data: $data) { 
        data{     
          id
      attributes {
        adl
        adltype
        detail          
        startdate
        enddate
        minute
        remind
        status
      }
    }
    }
  }
`;

export const GET_SCHEDULES_BY_ADL = gql`
query GetSchedulesByAdl($adlId: ID!) {
  residentschedules(filters: { adl: { id: { eq: $adlId } } }) {
    data {
      id
      attributes {
        time         
        type
        mo
        tu
        we
        th
        fr
        sa
        su
        residentadl {
          data {
            id
            attributes {
              adl
              adltype
              detail          
              startdate
              enddate
              minute
              remind
              status              
            }
          }
        }
      }
    }
  }
}
`;


export const GET_SCHEDULES = gql`
query{
    residentschedules{
      data{
        id
        attributes{   
          time         
          type
          mo
          tu
          we
          th
          fr
          sa
          su
        }
      }
    }
  }
`;


export const CREATE_SCHEDULE = gql`
  mutation Createresidentschedule($data: ResidentscheduleInput!) {
    createResidentschedule(data: $data) { 
        data{     
      attributes {
        time         
        type
        mo
        tu
        we
        th
        fr
        sa
        su
        publishedAt
      }
    }
    }
  }
`;
export const UPDATE_SCHEDULE = gql`
  mutation Updateresidentschedule($id: ID!, $data: ResidentscheduleInput!) {
    updateResidentschedule(id: $id, data: $data) { 
        data{     
          id
      attributes {
        time         
          type
          mo
          tu
          we
          th
          fr
          sa
          su
      }
    }
    }
  }
`;
